import { render, staticRenderFns } from "./ImportacaoErroTabela.vue?vue&type=template&id=2402cfa6&lang=html&"
import script from "./ImportacaoErroTabela.vue?vue&type=script&lang=js&"
export * from "./ImportacaoErroTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/importacao/ImportacaoErroTabela.vue
// module id = 1430
// module chunks = 28